// Executes the function after "delay" miliseconds of no typing
let THROTTLE
function throttle(executeFunction, event, delay) {
  clearTimeout(THROTTLE)
  THROTTLE = setTimeout(() => executeFunction(event), delay)
}
export default throttle
